import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import OtpInputComponent from "./OtpInput";
import { useOtpVerification } from "./useOtpVerification";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 16,
    minWidth: 400,
    maxWidth: 450,
    [theme.breakpoints.down("sm")]: {
      minWidth: 320,
      margin: 16,
    },
  },
}));

function OtpDialog({ open, onClose, tempToken, onSuccess }) {
  const {
    otp,
    setOtp,
    loading,
    error,
    setError,
    handleVerifyOtp,
    handleKeyPress,
    resetOtp,
  } = useOtpVerification(tempToken, onSuccess);

  const handleClose = () => {
    if (!loading) {
      onClose();
      resetOtp();
    }
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={loading}
    >
      {/* <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h5" component="div" sx={{ fontWeight: 600 }}>
          Two-Factor Authentication
        </Typography>
      </DialogTitle> */}

      <Divider />

      <DialogContent sx={{ pt: 3 }}>
        <OtpInputComponent
          otp={otp}
          setOtp={setOtp}
          error={error}
          setError={setError}
          onKeyPress={handleKeyPress}
          onVerify={handleVerifyOtp}
          autoFocus={true}
          label="6-digit verification code"
          infoText="The code refreshes every 30 seconds. Make sure to enter the current code from your authenticator app."
        />
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button onClick={handleClose} disabled={loading} variant="outlined">
          Cancel
        </Button>

        <Button
          onClick={handleVerifyOtp}
          disabled={otp.length !== 6 || loading}
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          {loading ? "Verifying..." : "Verify & Sign In"}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}

export default OtpDialog;
